/* eslint-disable no-unused-vars */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance,{ axiosInstance9000 } from "../api/axiosInstance";

export const fetchStatusPolicyDetail = createAsyncThunk(
  "statusPolicyDetail/fetchStatusPolicyDetail",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance9000.get("/api/insured/status/policy");
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.repsonse?.data || err.message);
    }   
  }
);

const statusPolicyDetailReducer = createSlice({
  name: "statusPolicyDetail",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchStatusPolicyDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStatusPolicyDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchStatusPolicyDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default statusPolicyDetailReducer;
